import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
import {
    Row,
    Col,
    CardBody,
    Card,
    Container,
    Label,
    Form,
    FormFeedback,
    Input,
    Button,
} from "reactstrap"
import { Alert, message as AntMessage, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useFormik } from "formik"
import * as Yup from "yup"
import { sendResetPasswordEmail } from "services/authservice"
import logoSm from "../../assets/images/logo-sm.png"
import logo from "../../assets/images/logo.png"

const { Paragraph, Text } = Typography

const ResetPasswordRequest = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [flashMessage, setFlashMessage] = useState(null)
    const [flashType, setFlashType] = useState("success")

    useEffect(() => {
        document.title = t('reset.title') || "Reset Password"
    }, [t])

    const formik = useFormik({
        initialValues: { email: "" },
        validationSchema: Yup.object({
            email: Yup.string()
                .email(t('reset.invalidEmail'))
                .required(t('reset.emailRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const response = await sendResetPasswordEmail(values.email)
                // AntMessage.success(t('reset.emailSent'))
                if (response?.status) {
                    AntMessage.success(response.message);
                } else {
                    AntMessage.error(response.message);
                }
                setTimeout(() => {
                    navigate('/reset-password', { state: { email: values.email } })
                }, 2000)
            } catch (error) {
                console.log(error)
                AntMessage.error(error.response?.data?.message || t('reset.error'))
            }
        },
    })

    return (
        <React.Fragment>
            <div className="d-flex justify-content-end">
                <div style={{ marginRight: "4%" }}>
                    <LanguageDropdown />
                </div>

                <div className="home-btn d-none d-sm-block">
                    <a href="/" className="text-dark">
                        <i className="fas fa-home h2" />
                    </a>
                </div>
            </div>

            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        {flashMessage && (
                            <Alert
                                banner
                                type={flashType}
                                showIcon
                                style={{ marginBottom: 24, borderRadius: 8 }}
                                message={(
                                    <Text strong style={{ fontSize: 16 }}>
                                        {flashType === "success"
                                            ? t('reset.successTitle')
                                            : t('reset.errorTitle')}
                                    </Text>
                                )}
                                description={(
                                    <Paragraph
                                        style={{ margin: 0, textAlign: "justify", lineHeight: 1.6 }}
                                    >
                                        {flashMessage}
                                    </Paragraph>
                                )}
                            />
                        )}

                        <Col md={8} lg={6} xl={4}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary text-center p-4">
                                    <h5 className="text-white font-size-20">
                                        {t('reset.header')}
                                    </h5>
                                    <p className="text-white-50">
                                        {t('reset.subHeader')}
                                    </p>
                                    <a href="/" className="logo logo-admin">
                                        <img src={logo} height="55" alt="logo" />
                                    </a>
                                </div>

                                <CardBody className="p-4">
                                    <div className="p-3">
                                        <Form
                                            className="mt-4"
                                            onSubmit={(e) => {
                                                e.preventDefault()
                                                formik.handleSubmit()
                                                return false
                                            }}
                                        >
                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="email">
                                                    {t('reset.emailLabel')}
                                                </Label>
                                                <Input
                                                    name="email"
                                                    type="email"
                                                    className="form-control"
                                                    placeholder={t('reset.emailPlaceholder')}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    invalid={
                                                        formik.touched.email && formik.errors.email
                                                    }
                                                />
                                                {formik.touched.email && formik.errors.email ? (
                                                    <FormFeedback type="invalid">
                                                        {formik.errors.email}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="text-end">
                                                <Button
                                                    color="primary"
                                                    className="w-md waves-effect waves-light"
                                                    type="submit"
                                                >
                                                    {t('reset.submitButton')}
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="mt-5 text-center">
                                <p>
                                    {t('reset.remembered')}{" "}
                                    <a href="/login" className="fw-medium text-primary">
                                        {t('reset.loginLink')}
                                    </a>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

ResetPasswordRequest.propTypes = {
    // No props
}

export default ResetPasswordRequest
